import React from "react";
import { Link } from "react-router-dom";
import { Users, Fuel, Settings, Briefcase, ArrowRight } from "lucide-react";
import { formatGHS, formatCarName } from "@/lib/api";

const CAT_LABELS = {
  sedan: "Sedan",
  compact_suv: "Mid-size SUV",
  full_suv: "Full-size SUV",
  van: "Van / Bus",
  luxury: "Luxury",
  economy: "Economy",
  suv: "SUV",
};

export default function CarCard({ car, index = 0 }) {
  const outside = car.daily_rate_outside && car.daily_rate_outside !== car.daily_rate;
  const displayName = formatCarName(car);
  return (
    <div
      className="fleet-card bg-white border border-gray-200 flex flex-col"
      data-testid={`car-card-${car.id}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="aspect-[16/10] bg-[#f7f8fa] flex items-center justify-center overflow-hidden">
        <img
          src={car.image_url}
          alt={displayName}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-2 mb-3">
          <div>
            <span className="tag-badge">{CAT_LABELS[car.category] || car.category}</span>
            <h3 className="font-display text-xl font-semibold text-[#0d2040] mt-2">
              {displayName}
            </h3>
          </div>
          <div className="text-right">
            <div className="text-[0.62rem] text-gray-500 uppercase tracking-wider">Within Accra</div>
            <div className="font-display text-2xl font-bold text-[#e63946] leading-none">{formatGHS(car.daily_rate)}</div>
            {outside && (
              <div className="text-[0.7rem] text-gray-600 mt-1.5">
                Outside Accra: <span className="font-semibold text-[#0d2040]">{formatGHS(car.daily_rate_outside)}</span>
              </div>
            )}
            <div className="text-[0.62rem] text-gray-500 uppercase tracking-wide mt-0.5">/ day</div>
          </div>
        </div>

        <div className="grid grid-cols-4 gap-2 text-xs text-[#0d2040] border-t border-gray-100 pt-3">
          <div className="flex items-center gap-1.5">
            <Users size={13} className="text-gray-400" /> {car.seats}
          </div>
          <div className="flex items-center gap-1.5">
            <Settings size={13} className="text-gray-400" /> {car.transmission === "automatic" ? "Auto" : "Man"}
          </div>
          <div className="flex items-center gap-1.5">
            <Fuel size={13} className="text-gray-400" /> {car.fuel}
          </div>
          <div className="flex items-center gap-1.5">
            <Briefcase size={13} className="text-gray-400" /> {car.luggage}
          </div>
        </div>

        <Link
          to={`/cars/${car.id}`}
          className="btn-primary mt-5 w-full"
          data-testid={`car-card-book-${car.id}`}
        >
          View & Book <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
